import Swiper from "swiper";
import {createSwiper} from "../utils/swiper";

export const CardsSlider = {
	swiper: null as Swiper | null,

	init(): void {
		this.swiper = createSwiper('.wv-cards-slider', 'wv-card', {
			autoplay: {
				delay: 1500,
				disableOnInteraction: true
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 8,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 20,
				}
			},
			centeredSlides: true,
			direction: "horizontal",
			loop: true,
			mousewheel: true
		});
	},

};
